import { Add as AddIcon, Build as BuildIcon, MoreVert as MoreVertIcon } from "@mui/icons-material";
import { SwipeableDrawer } from "@mui/material";
import { styled } from "@mui/material/styles";
import PrimaryButton from "components/PrimaryButton";
import StyledFabFixed from "components/StyledFabFixed";
import technicianSettings from "helpers/technicianSettings";
import { EditAvailabilityDialog } from "pages/dialogs/EditAvailabilityDialog";
import { CreateJobDialog } from "pages/jobs/dialogs/CreateJobDialog";
import { FC, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useAppDispatch, useAppSelector } from "store";
import { selectConnectionStatus } from "store/root.store";
import { setOpen } from "store/slices/dialog.store";
import {
  selectCreateJobOpen,
  setOpen as setOpenCreateJobDialog,
} from "store/slices/dialogs/createJob.store";

const StyledContainer = styled("div")(() => ({
  zIndex: "9001",
}));

export const JobCalendarActions: FC = (props) => {
  const dispatch = useAppDispatch();
  const openAvailability = useAppSelector((s) => s.dialog.availability);
  const isOnline = useAppSelector(selectConnectionStatus);
  const openCreateJobDialog = useAppSelector(selectCreateJobOpen);
  const canCreateJob = technicianSettings.canCreateJob && isOnline;
  const [openDrawer, setOpenDrawer] = useState(false);

  return (
    <>
      <StyledFabFixed
        color="primary"
        component="span"
        onClick={() => setOpenDrawer(true)}
        data-testid="JobCalendarActions-OpenButton"
      >
        <MoreVertIcon />
      </StyledFabFixed>
      <StyledContainer data-testid="JobCalendarActions-Container">
        <SwipeableDrawer
          anchor="bottom"
          open={openDrawer}
          onOpen={() => setOpenDrawer(true)}
          onClose={() => setOpenDrawer(false)}
        >
          <div style={{ margin: "0px 16px" }} data-testid="JobCalendarActions-Drawer">
            <PrimaryButton
              data-testid="JobCalendarActions-AddAvailability"
              onClick={() => {
                dispatch(setOpen({ dialogName: "availability", open: true }));
                setOpenDrawer(false);
              }}
              startIcon={<AddIcon />}
              style={{ textTransform: "none" }}
            >
              <FormattedMessage id="availability.add" />
            </PrimaryButton>
            {canCreateJob && (
              <PrimaryButton
                data-testid="createJobButton"
                onClick={() => {
                  dispatch(setOpenCreateJobDialog({ open: true }));
                  setOpenDrawer(false);
                }}
                startIcon={<BuildIcon />}
                style={{ textTransform: "none" }}
              >
                <FormattedMessage id="menu.createNewJob" />
              </PrimaryButton>
            )}
          </div>
        </SwipeableDrawer>
        {canCreateJob && openCreateJobDialog && <CreateJobDialog />}
        {openAvailability && <EditAvailabilityDialog />}
      </StyledContainer>
    </>
  );
};
